import { StatusUpdateStatuses } from 'api/status-updates/types';
import { FieldType, SourceType } from 'components/organisms/tasks/fields';
export const ProjectFieldsName = {
    pastProjectStatus: 'pastProjectStatus',
    projectMinutes: 'projectMinutes',
    billableMinutes: 'billableMinutes',
    // Backend API expects 'lastMilestoneCSAT' (uppercase CSAT) for sort, filter,
    // and data responses. However, ag-grid colIds use camelCase(fieldName) which
    // lodash converts to 'lastMilestoneCsat'. Places that bridge the two:
    //   - getSortAsString camelCase fallback in projects-list-data-source.tsx
    //   - value-getter.ts (reads data?.lastMilestoneCSAT explicitly)
    //   - defaultColumnOrder in columns.ts uses 'lastMilestoneCsat' (ag-grid side)
    //   - field normalization in col-paginated-grid/index/dashboards-project-list
    lastMilestoneCSAT: 'lastMilestoneCSAT',
    csatRating: 'csatRating',
    projectPhases: 'projectPhases',
    inferredProgress: 'inferredProgress',
    status: 'status',
    projectName: 'projectName',
    progressPercent: 'progressPercent',
    estimatedDueDate: 'estimatedDueDate',
    arr: 'arr',
    projectFee: 'projectFee',
    dueDate: 'dueDate',
    startDate: 'startDate',
    projectAge: 'projectAge',
    plannedDuration: 'plannedDuration',
    startDateActual: 'startDateActual',
    dueDateActual: 'dueDateActual',
    projectBudget: 'projectBudget',
    estimateAtCompletion: 'estimateAtCompletion',
    projectOwner: 'projectOwner',
    teamMembers: 'teamMembers',
    placeholders: 'unresolvedPh',
    autoAllocation: 'autoAllocation',
    estimateToComplete: 'estimateToComplete',
    customer: 'customer',
    financialContractType: 'financialContractType',
    revenueRecognitionType: 'revenueRecognitionType',
    currency: 'currency',
    actualRevenue: 'actualRevenue',
    totalRecognisedRevenue: 'totalRecognisedRevenue',
    actualCost: 'actualCost',
    actualProfit: 'actualProfit',
    actualProfitMargin: 'actualProfitMargin',
    percentageBudgetedHoursConsumed: 'percentageBudgetedHoursConsumed',
    percentageBudgetConsumed: 'percentageBudgetConsumed',
    subscriptionFrequency: 'subscriptionFrequency',
    numberOfPeriods: 'numberOfPeriods',
    currentPeriodNumber: 'currentPeriodNumber',
    currentPeriodStartDate: 'currentPeriodStartDate',
    currentPeriodEndDate: 'currentPeriodEndDate',
    periodBudget: 'periodBudget',
    periodMinutes: 'periodMinutes',
    periodRevenue: 'periodRevenue',
    periodTotalTimeTracked: 'periodTotalTimeTracked',
    remainingMinutes: 'remainingMinutes',
    currentPhases: 'currentPhases',
    template: 'template'
};
export const PastProjectStatusField = {
    fieldId: -100001,
    fieldName: ProjectFieldsName.pastProjectStatus,
    fieldLabel: 'last_status_update',
    type: FieldType.SingleSelect,
    metaData: {
        options: Object.values(StatusUpdateStatuses).map((opt)=>({
                ...opt,
                value: opt.label
            }))
    },
    customField: false,
    userCreated: false,
    private: false,
    sourceType: SourceType.Project
};
export const LastMilestoneRatingField = {
    fieldId: -100002,
    fieldName: ProjectFieldsName.lastMilestoneCSAT,
    fieldLabel: 'last_milestone_rating',
    type: FieldType.Number,
    customField: false,
    userCreated: false,
    private: false,
    sourceType: SourceType.Project
};
export const CsatRatingField = {
    fieldId: -100003,
    fieldName: ProjectFieldsName.csatRating,
    fieldLabel: 'overall_rating',
    type: FieldType.Number,
    customField: false,
    userCreated: false,
    private: false,
    sourceType: SourceType.Project
};
export const ProjectHoursField = {
    fieldId: -100004,
    fieldName: ProjectFieldsName.projectMinutes,
    fieldLabel: 'projects.list.project_hours',
    type: FieldType.Number,
    customField: false,
    userCreated: false,
    private: false,
    sourceType: SourceType.Project
};
export const ProjectPhasesField = {
    fieldId: -100005,
    fieldName: ProjectFieldsName.projectPhases,
    fieldLabel: 'projects.list.project_phases',
    type: FieldType.MultiSelect,
    metaData: {
        options: []
    },
    customField: false,
    userCreated: false,
    private: false,
    sourceType: SourceType.Project
};
export const BillableHoursField = {
    fieldId: -100006,
    fieldName: ProjectFieldsName.billableMinutes,
    fieldLabel: 'projects.list.billable_hours',
    type: FieldType.Number,
    customField: false,
    userCreated: false,
    private: false,
    sourceType: SourceType.Project
};
export const ProgressField = {
    fieldId: -100007,
    fieldName: ProjectFieldsName.progressPercent,
    fieldLabel: 'project.fields.progress',
    type: FieldType.Number,
    customField: false,
    userCreated: false,
    private: false,
    sourceType: SourceType.Project
};
